// istanbul ignore file
export default {
  nav: {
    label: 'Bottomline Technologies navigation',
    openNavigation: 'Open navigation',
    backToPage: 'Back to page',
    closeNavigation: 'Close navigation',
    close: 'Close',
    open: 'Open',
    accountAVatar: 'Account Avatar',
    foldedTitle: 'More',
    lastLogin: 'Last login'
  }
};
